import React, { Component } from 'react';

const startCount = 10
const finishCount = 10

class Cache extends Component {

    constructor(props) 
    {
        super(props)

        this.state = {
            cache: props.cache,
            updateApp: props.updateApp,
            application: props.application,
            showData: props.showData,
            
        }

        this.handleCacheOper = this.handleCacheOper.bind(this)
        this.handleDataView = this.handleDataView.bind(this)
        this.handleDataDownload = this.handleDataDownload.bind(this)
        this.handleManifestView = this.handleManifestView.bind(this)

    }
    

    handleCacheOper(event)
    {
        if (this.state.cache[event.target.name](event.target.value))
            this.state.updateApp()
           

    }


    strDigest(data)
    {
        let str = data
        
        if (typeof data !== 'string')
            str = new Uint8Array(data).toString()
        
        if ( str.length > (startCount + finishCount) )
            return str.substr(0, startCount) + "..." + str.substr((str.length - finishCount), finishCount)
        else
            return str
    }


    viewManifestButton(doi) {
        return <button className="btn btn-sm btn-success " onClick={this.handleManifestView} value={doi}>View Manifest</button>
        
    }


    handleManifestView(event)
    {

        let manifest = this.state.cache.get_manifest_by_doi(event.target.value);
        this.state.application.updateDataView({MIME : "manifest", data : manifest.data});
        this.props.dataTogglePopup();

        
    }


    viewDataButton(doi)
    {

        let manifest = this.state.cache.get_manifest_by_doi(doi);
        let data = this.state.cache.get_data_by_doi(doi);
        
        if (manifest.status && data.status && manifest.data !== null) 

            return <button className="btn btn-sm btn-success" onClick={this.handleDataView} value={doi}>View Data</button>
        else
            return ""
    };


    
    handleDataView(event)
    {

        let manifest = this.state.cache.get_manifest_by_doi(event.target.value);
        let data = this.state.cache.get_data_by_doi(event.target.value);

         this.state.application.updateDataView({MIME : manifest.data.get_mime().data, data : data.data});
         this.props.dataTogglePopup();
         //console.log(this.props.showData);
      
        

        
    }


    DataDownloadButton(doi)
    {
        let manifest = this.state.cache.get_manifest_by_doi(doi);
        let data = this.state.cache.get_data_by_doi(doi);

        if (("ok" === data.status) && ("ok" === manifest.status))
            return <button className="btn btn-sm btn-success" onClick={this.handleDataDownload} value={doi}>Download</button>
        else
            return ""
    };

    handleDataDownload(event)
    {
        let manifest = this.state.cache.get_manifest_by_doi(event.target.value);
        
        let mime = manifest.data.get_mime()
        if ("ok" !== mime.status)
            return
        
        let doi = manifest.data.get_doi()
        if ("ok" !== doi.status)
            return

        let ext = ""
        if ( mime.data === "application/vnd.openxmlformats-officedocument.presentationml.presentation" )
            ext = ".pptx"

        if ( mime.data === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" )
            ext = ".docx"

        if ( mime.data === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" )
            ext = ".xlsx"

        let data = this.state.cache.get_data_by_doi(event.target.value);    

        var blob = new Blob([data.data], {type: mime.data});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = doi.data[0] + ext;

        link.click();
    }


    render()
    {
        let cache = this.state.cache

        let cm = cache.get_cached_manifests()
        let cd = cache.get_cached_data()
        const col6 = "col-md-6 alert alert-success alert-dismissible fade show"
        
        let cachedManifests = cm.map(value => 
        <div className="row">
        <div className={col6} title={value.doi}> {this.strDigest(value.doi)}</div>
        <div className={col6}>{this.strDigest(JSON.stringify(value.value))}</div>
        
        <div className="col-md-6" >{this.viewManifestButton(value.doi)}</div>
        <div className="col-md-6"><button className="btn btn-sm btn-danger" onClick={this.handleCacheOper} name="delete_manifest_by_doi" value={value.doi}>Delete</button>
        </div>
        <div className="col-md-12 p-2"></div></div>)
        let cachedData = cd.map(value => 
            <div className="row">
            <div className={col6} title={value.doi}>{this.strDigest(value.doi)}</div>
            <div className={col6}>{this.strDigest(value.value)} Data length = {value.value.length}</div>
            
            
            <div className="col-md-6" >{this.viewDataButton(value.doi)}{this.DataDownloadButton(value.doi)}</div>
            <div className="col-md-6"><button className="btn btn-sm btn-danger" onClick={this.handleCacheOper} name="delete_data_by_doi"
             value={value.doi}>Delete</button></div></div>
             )

        return (
               
                <div className="Cache col-lg-12 bg-secondary m-2 text-white" /*style={{display: cache.get_cached_manifests_size() || cache.get_cached_data_size() !== 0 ? 'block' : 'none'}}*/>
                
                    
                    <div className="col-md-12 font-weight-bold"> CACHE </div>
                    
                    <div className="row m-2">
                    <div className="col-md-6 text-md-left font-weight-bold p-1">Entity type</div>
                    <div className="col-md-6 text-md-right font-weight-bold p-1">Count</div>
                    <div className="col-md-12 border-bottom"></div>
                    </div>
                    
                    <div className="row m-2">
                    <div className="col-md-11 text-md-left p-1">Manifest</div>
                    <div className="col-md-1 alert alert-success alert-dismissible fade show p-1">{cache.get_cached_manifests_size()}</div>
                    </div>
                    <div className="row m-2">
                    <div className="col-md-11 text-md-left p-1">Data</div>
                    <div className="col-md-1  alert alert-success alert-dismissible fade show p-1" >{cache.get_cached_data_size()}</div>
                   </div>
                    <div className="col-md-12 border-bottom"></div>
                    <div className="col-md-12"><button className="btn btn-sm btn-warning m-3" onClick={this.handleCacheOper} 
                    name="clear" value="()">Clear</button></div>
                        
                    
                    <div className="col-md-6 text-md-left font-weight-bold p-2">DOI</div>
                    <div className="col-md-6 text-md-left font-weight-bold p-2">Manifest</div>
                    
                    
                          {cachedManifests} 
                    
                    
                    <div className="col-md-12 p-3 border-bottom"></div>
                    <div className="col-md-6  text-md-left font-weight-bold p-2">DOI</div>
                    <div className="col-md-6  text-md-left font-weight-bold p-2">Data</div>
                    
                   
                            {cachedData}
                        
                        
                              </div>
        );
    }
}

export default Cache;